import SearchField from "./SearchField";

export type { Suggestion as SearchFieldSuggestion } from "./SearchField";
export default SearchField;
